export default __webpack_public_path__ + "static/media/empty_todos.228a4892.svg";